import { log } from '../../log';

/**
 * @description 事件通信类
 * @author aprilcai
 */
export interface F {
  id?: number;
  once?: boolean;
  (data?: any): any;
}

const findById = (arr: Array<F>, fn: any) => {
  let i = 0;
  const len = arr.length;
  for (; i < len; i += 1) {
    if (arr[i].id === fn.id) {
      return i;
    }
  }
  return -1;
};

export default class EventEmitter {
  public static F: F;
  private id: number;
  private fns: Map<string, Array<F>>;

  public constructor() {
    this.fns = new Map();
    this.id = new Date().getTime();
  }

  public on(event: string, fn: F) {
    // eslint-disable-next-line no-param-reassign
    fn.id = this.id;
    this.id += 1;
    if (!this.fns.has(event)) {
      this.fns.set(event, []);
    }
    const fns = this.fns.get(event);
    fns.push(fn);
  }

  public off(event: string, fn?: F): void {
    const fns = this.fns.get(event);
    if (!fns) return;
    if (!fn) {
      this.fns.set(event, []);
      return;
    }
    const index = findById(fns, fn);
    if (index === -1) return;
    fns.splice(index, 1);
  }

  public once(event: string, fn: any) {
    // eslint-disable-next-line no-param-reassign
    fn.once = true;
    this.on(event, fn);
  }

  public emit(event: string, data?: any) {
    let fns = this.fns.get(event);
    if (!fns) return;
    let i = 0;
    for (; i < fns.length; i += 1) {
      const fn = fns[i] as F;
      try {
        fn(data);
      } catch (e) {
        log('[adapter-bridge/txv/webview]event-emitter.emit throw an error: ', e);
      }
    }
    fns = fns.filter(f => !f.once);
    this.fns.set(event, fns);
  }
}
